import React, {Component} from 'react'
import CircularProgress from "@material-ui/core/CircularProgress";
import {Backdrop} from '@material-ui/core';
import './loading.scss'
import {loaderConfig} from "./index";

interface IProps {
}

interface IState {
    show: boolean,
    content?: string
}

class Loader extends Component <IProps, IState> {
    constructor(props: IProps) {
        super(props)
        this.state = {
            show: false
        }
    }

    showLoading(config: loaderConfig) {
        this.setState({show: true, content: config.content})
        return () => {
            this.hideLoading()
        }
    }

    hideLoading() {
        this.setState({show: false})
    }

    render() {
        if (!this.state.show) {
            return null
        }
        return (
            <div className="s4p-loader">
                <Backdrop open={true}/>
                <div>
                    <CircularProgress style={{color: '#fff'}}/>
                    {this.state.content ?
                        <div className="loader-text">{this.state.content}</div> : null}
                </div>
            </div>
        )
    }
}

export default Loader